<template>
  <div>
    <!-- 筛选项 -->
    <FilterLayout v-model="searchForm" @onSubmit="onSubmit" width="100px" :mdSpan="6" :flexFlag="true">
      <div class="component_title2">筛选项</div>
      <el-col :md="6" :lg="6" :sm="12">
        <el-form-item label="日期">
          <dataPicker :datevalue.sync="searchForm.time"></dataPicker>
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="事业群" prop="apartment_id">
          <SelectCustomize :value="departmentInfo" @changeScope="changeProjectTeam" :data="apartment_id" />
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="部门" prop="group_id">
          <SelectCustomize :value="groupIdInfo" @changeScope="changeApp" :data="group_id" />
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="项目" prop="project_id">
          <SelectCustomize :value="projectInfo" @changeScope="changeArticle" :data="article_id" />
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="应用" prop="appid">
          <SelectCustomize :value="appidInfo" @changeScope="changeAppid" :data="apps" />
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="系统" prop="system">
          <SelectCustomize :value="systemInfo" @changeScope="changeSystem" :data="systemIds" />
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-form-item label="时间周期" prop="timeType">
          <el-select v-model="searchForm.timeType" placeholder="请选择" :popper-append-to-body="false">
            <el-option v-for="(v, i) in timeType" :key="i" :label="v.title" :value="v.id" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-button @click="initFrom" slot="btn-option">重置筛选</el-button>
    </FilterLayout>
    <!-- 数据报表 -->
    <TableLayout tableType="multilLevelHeader" :column="changeColumn" :childColumn="childColumn" :data="tableData.data"
      :total="tableData.total" :loading="tableData.loading" :currentPage="tableOpt.currentPage" :leadOut="true"
      alignStyle="center" author="new" @leadOutClick="leadOutClick" leadApi="Operations_Overview/lists"
      @pageChange="onPageChange" @sizeChange="onSizeChange" @sortChange="onSortChange" :childList="true" :key="tableKey"
      ref="tableLayout" :defaultSort="sort">
      <div class="component_title" slot="title">数据报表</div>
      <!-- <div class="table-tabs" slot="tabs">
        <span
          class="items"
          :class="tableActiveIndex == k.id ? 'active' : ''"
          v-for="k in orderpackageTypes"
          :key="k.id"
          @click="orderpackageTypeClick(k.id)"
        >
          {{ k.label }}
        </span>
      </div> -->
      <div slot="table-option" class="Tab_box">
        <div class="left_box">
          <span class="font14">数据维度（多选）</span>
          <el-select v-model="group" placeholder="全部渠道" :popper-append-to-body="false" :reserve-keyword="true" filterable
            multiple collapse-tags class="my-select" @change="changeTable" @remove-tag="handleRemoveTag">
            <div class="check-all">
              <el-checkbox v-model="all" @input="changeDimensional">全部勾选</el-checkbox>
            </div>
            <el-option v-for="(v, i) in dimensionalData" :key="i" :value="v.value" :label="v.title" :disabled="group.length == 1 && group[0] == v.value ? true : false
              " />
          </el-select>
          <el-checkbox style="margin-left: 20px" v-model="flexFlag" @input="changeTableList">冻结维度项</el-checkbox>
        </div>
        <!-- <TransferDialog
          :data1="this.paramDetailData.showField"
          :data2="this.paramDetailData.hiddenField"
          @paramSave="paramSave"
          @initData="initData"
          postApi="Business/paramDetail"
          :postParams="customFieldParams"
          transferCard="index"
        >
        </TransferDialog> -->
      </div>
      <template #date="{ row }">
        {{ row.date }}
      </template>
    </TableLayout>
  </div>
</template>

<script>
import moment from "moment";
import store from "store2";
import { Mydata } from "./mixins/index.js";
import FilterLayout from "@/layout/form";
import TableLayout from "@/layout/table";
import TransferDialog from "@/layout/transferDialog";
import SelectCustomize from "@/component/select-customize";
export default {
  mixins: [Mydata],
  components: {
    FilterLayout,
    SelectCustomize,
    TableLayout,
    TransferDialog,
  },
  computed: {
    // 字段展示自定义携带参数
    customFieldParams() {
      return {
        timeStart: this.searchForm["time"][0],
        timeEnd: this.searchForm["time"][1],
      };
    },
    // 数据发生变化重新计算表头数据
    changeColumn() {
      let arr = [];
      let columu = [
        {
          label: "日期",
          prop: "date",
          sortable: "custom",
          value: 1000,
        },
        {
          label: "项目",
          prop: "project_name",
          value: 1003,
        },
        {
          label: "事业群",
          prop: "apartment_name",
          value: 1001,
        },
        {
          label: "部门",
          prop: "group_name",
          value: 1002,
        },
        {
          label: "应用",
          prop: "app_name",
          value: 1004,
        },
        {
          label: "系统",
          prop: "system_name",
          value: 1005,
        },
      ];
      let all = {};
      let mean = {};
      let weekFlag = false;
      // 判断所选数据维度，重新计算表格数据
      if (this.group.length) {
        this.group.forEach((item) => {
          columu.forEach((_item) => {
            if (_item.value == item) {
              if (this.flexFlag) {
                _item.fixed = "left";
              } else {
                _item.fixed = "";
              }
              arr.push(_item);
            }
            if (
              _item.value == item &&
              _item.prop == "date" &&
              this.timeTypeFlag
            ) {
              if (this.flexFlag) {
                arr.push({
                  fixed: "left",
                  label: "星期",
                  prop: "week",
                });
              } else {
                arr.push({
                  label: "星期",
                  prop: "week",
                });
              }
              weekFlag = true;
            }
            if (item == 1000) {
            }
          });
        });
      } else {
        arr = [...columu];
      }
      // 为表头插入总计和均值
      all[arr[0].prop] = "总计";
      mean[arr[0].prop] = "均值";
      /* this.paramDetailData.showField.forEach((item) => {
        this.column.forEach((_item) => {
          if (item.value == _item.label) {
            all[_item.prop] = this.sumList[_item.prop];
            mean[_item.prop] = this.avgList[_item.prop];
            arr.push({
              label: item.value,
              prop: _item.prop,
              sortable: _item.sortable,
            });
          }
        });
      }); */
      this.column.forEach((item) => {
        if (item.children && item.children.length) {
          item.children.forEach((_item) => {
            all[_item.prop] = this.sumList[_item.prop];
            mean[_item.prop] = this.avgList[_item.prop];
          });
        } else {
          all[item.prop] = this.sumList[item.prop];
          mean[item.prop] = this.avgList[item.prop];
        }
      });
      // 表格数据的赋值
      if (
        this.tableData.data[0] &&
        this.tableData.data[0][arr[0].prop] != "总计"
      ) {
        this.tableData.data = [all, mean, ...this.tableData.data];
      }
      this.tableData.data.forEach((item) => {
        if (item.date != "总计" && item.date != "均值" && weekFlag && this.searchForm.timeType == '1') {
          item.week = moment(item.date).format("dddd");
        }
      });
      /* this.tableData.data.forEach((item) => {
        if (item.app_name) {
          item.app_name = item.app_name + "-" + item.system_name;
        }
      }); */
      arr = [...arr, ...this.column];
      return arr;
    },
    childColumn() {
      let column = [];
      let arr = JSON.parse(JSON.stringify(this.changeColumn));
      arr.forEach((item) => {
        if (item.children) {
          item.children.forEach((_item) => {
            column.push(_item);
          });
        } else {
          column.push(item);
        }
      });
      // this.tableKey += 1;
      return column;
    },
    /*  outPamrms() {
      const { searchForm, group, tableOpt } = this;
      return {
        ...searchForm,
        ...tableOpt,
        group: group.sort(function (a, b) {
          return a - b;
        }),
      };
    }, */
  },
  watch: {
    group() {
      this.tableKey += 1;
    },
  },
  data() {
    return {
      moment: moment,
      // 表格的筛选项
      searchForm: {
        project_id: [], //项目
        appid: [], //应用
        system: [], //系统
        channe: [], //渠道
        timeType: "1", //时间周期
        apartment_id: [], //事业群
        group_id: [], // 部门
        time: [
          moment().subtract(7, "d").format("YYYY-MM-DD"),
          moment().subtract(1, "d").format("YYYY-MM-DD"),
        ], //时间
      },
      departmentInfo: {
        appInfo: [], //事业群-组件列表数据
      },
      groupIdInfo: {
        appInfo: [], //部门-组件列表数据
      },
      projectInfo: {
        appInfo: [], //部门-组件件初始数据
      },
      appidInfo: {
        appInfo: [], //应用-组件列表数据
      },
      systemInfo: {
        appInfo: [], //系统-组件列表数据
      },
      apps: [], //应用-组件回调所选值
      article_id: [], //项目-组件回调所选值
      apartment_id: [], //事业群-组件回调所选值
      group_id: [], //部门-组件回调所选值
      group: [1000], //投放维度的所选值
      all: false, //数据维度全选标杆
      flexFlag: false, //冻结维度的标杆
      //字段展示自定义
      paramDetailData: {
        showField: [], //显示列表
        hiddenField: [], //隐藏列表
      },
      sumList: [], //总值
      avgList: [], //均值
      // 表格数据
      tableData: {
        data: [], //数据
        total: 0, //总页数
        currentPage: 1, //当前页
        pageSize: 10, //每页条数
        loading: false, //加载标杆
      },
      tableActiveIndex: 1, // table报表tab选项卡选择的id
      selfCustomFiledIndex: 1, // 自定义字段tab选项卡选择的id
      // table表格的切换项
      orderpackageTypes: [
        {
          label: "实际消耗",
          id: 1,
        },
        {
          label: "账面消耗",
          id: 2,
        },
      ],
      // 时间周期的变化情况
      timeTypeFlag: true,
      tableKey: 1,
      sort: { prop: "", order: "" },
    };
  },
  mounted() {
    // 初始化调用部门分组
    this.getRoleBtree();
    // 调用列表接口
    this.getReport();
  },
  methods: {
    // 获取app事业群分组
    async getRoleBtree() {
      const [err, res] = await this.$http.post("System/roleBtree", {
        loginId: store.get("user")["id"],
        loginToken: store.get("loginToken"),
      });
      if (err) return;
      this.apartment_id = res.tree;
      res.list.forEach((item) => {
        if (item.title == "应用") {
          item.node.forEach((_item) => {
            if (_item.system == "1") {
              _item.title = _item.title + "_Android";
            } else if (_item.system == "2") {
              _item.title = _item.title + "_IOS";
            } else if (_item.system == "3") {
              _item.title = _item.title + "_微信小程序";
            }
          });
        }
      });
      this.departDatas = [
        ...res.list,
        { id: 1005, title: "系统", node: [...this.systemIds] },
      ];
      let group_id = [];
      res.tree.forEach((item) => {
        item.node.forEach((_item) => {
          group_id.push(_item);
        });
      });
      this.group_id = group_id;
      let apps = [];
      let article_id_arr = [];
      res.tree.forEach((item) => {
        item.node.forEach((_item) => {
          article_id_arr.push(..._item.node);
          _item.node.forEach((__item) => {
            apps.push(...__item.node);
          });
        });
      });
      this.apps = apps;
      this.article_id = article_id_arr;
    },
    // 改变部门与app
    changeProjectTeam(val) {
      this.searchForm.apartment_id = val.appInfo;
      this.searchForm.group_id = [];
      this.searchForm.appid = [];
      this.searchForm.project_id = [];
      this.groupIdInfo.appInfo = [];
      this.projectInfo.appInfo = [];
      this.appidInfo.appInfo = [];
      let group_id_arr = [];
      let apps_arr = [];
      let article_id_arr = [];
      this.searchForm.apartment_id.forEach((item) => {
        this.apartment_id.forEach((_item) => {
          if (item == _item.id) {
            group_id_arr = [..._item.node, ...group_id_arr];
            _item.node.forEach((__item) => {
              article_id_arr.push(...__item.node);
              __item.node.forEach((item_) => {
                apps_arr.push(...item_.node);
              });
            });
          }
        });
      });
      this.group_id = [...group_id_arr];
      this.article_id = [...article_id_arr];
      this.apps = apps_arr;
      if (!val.appInfo.length) {
        this.getRoleBtree();
      }
    },
    // 改变app与事业群
    changeApp(val) {
      this.searchForm.group_id = val.appInfo;
      this.searchForm.appid = [];
      this.searchForm.project_id = [];
      this.projectInfo.appInfo = [];
      this.appidInfo.appInfo = [];
      let apps_arr = [];
      let article_id_arr = [];
      if (this.searchForm.group_id.length) {
        this.searchForm.group_id.forEach((item) => {
          this.apartment_id.forEach((_item) => {
            _item.node.forEach((__item) => {
              if (item == __item.id) {
                article_id_arr.push(...__item.node);
                __item.node.forEach((item_) => {
                  apps_arr.push(...item_.node);
                });
              }
            });
          });
        });
      } else {
        this.group_id.forEach((item) => {
          this.apartment_id.forEach((_item) => {
            _item.node.forEach((__item) => {
              if (item.id == __item.id) {
                article_id_arr.push(...__item.node);
                __item.node.forEach((item_) => {
                  apps_arr.push(...item_.node);
                });
              }
            });
          });
        });
      }
      this.apps = apps_arr;
      this.article_id = [...article_id_arr];
    },
    // 改变项目
    changeArticle(val) {
      this.searchForm.project_id = val.appInfo;
      this.searchForm.appid = [];
      this.appidInfo.appInfo = [];
      let apps_arr = [];
      if (this.searchForm.project_id.length) {
        this.searchForm.project_id.forEach((item) => {
          this.apartment_id.forEach((_item) => {
            _item.node.forEach((__item) => {
              __item.node.forEach((item_) => {
                if (item == item_.id) {
                  apps_arr.push(...item_.node);
                }
              });
            });
          });
        });
      } else {
        this.article_id.forEach((item) => {
          apps_arr.push(...item.node);
        });
      }
      this.apps = apps_arr;
    },
    // 筛选应用的回调函数
    changeAppid(val) {
      this.searchForm.appid = val.appInfo;
    },
    // 筛选系统的回调函数
    changeSystem(val) {
      this.searchForm.system = val.appInfo;
    },
    // 表单查询
    onSubmit() {
      this.tableOpt.currentPage = 1;
      this.getReport();
    },
    // 重置表单
    initFrom() {
      this.departmentInfo.appInfo = [];
      this.groupIdInfo.appInfo = [];
      this.projectInfo.appInfo = [];
      this.appidInfo.appInfo = [];
      this.systemInfo.appInfo = [];
      this.searchForm = {
        project_id: [], //项目
        appid: [], //应用
        system: [], //系统
        channe: [], //渠道
        timeType: "1", //时间周期
        apartment_id: [], //事业群
        group_id: [], // 部门
        time: [
          moment().subtract(7, "d").format("YYYY-MM-DD"),
          moment().subtract(1, "d").format("YYYY-MM-DD"),
        ], //时间
      };
    },
    // 每页改变回调
    onPageChange(current) {
      this.tableOpt.currentPage = current;
      this.getReport();
    },
    // 每页条数改变回调
    onSizeChange(current) {
      this.tableOpt.pageSize = current;
      this.getReport();
    },
    // 表格排序的回调
    onSortChange(data) {
      let { prop, order } = data;
      if (order) {
        order = order == "ascending" ? "asc" : "desc";
      } else {
        order = "";
      }
      this.sort = { prop, order };
      console.log(this.sort, 66);
      this.getReport();
    },
    // 改变数据维度的回调函数
    changeTable(val) {
      this.getReport();
    },
    // 数据维度全选的回调函数
    changeDimensional(val) {
      if (val) {
        this.group = [1000, 1001, 1002, 1003, 1004, 1005];
      } else {
        this.group = [1000];
      }
      this.getReport();
    },
    // 冻结列表的回调函数
    changeTableList(val) {
      this.group.forEach((item) => {
        this.changeColumn.forEach((_item) => {
          if (_item.value == item) {
            if (this.flexFlag) {
              _item.fixed = "left";
            } else {
              _item.fixed = "";
            }
          }
          if (item == 1000) {
            if (this.flexFlag) {
              if (_item.prop == "week") {
                _item.fixed = "left";
              }
            }
          }
        });
      });
    },
    // 保存自定义字段
    async paramSave(val) {
      this.tableData.loading = true;
      const [err, res] = await this.$http.post("Business/paramSave", {
        timeStart: this.searchForm["time"][0],
        timeEnd: this.searchForm["time"][1],
        ...val,
      });
      if (err) return;
      this.getReport();
      this.getParamDetail();
    },
    // 获取自定义字段
    async getParamDetail() {
      const [err, res] = await this.$http.post("Business/paramDetail", {
        cate: 1,
        timeStart: this.searchForm["time"][0],
        timeEnd: this.searchForm["time"][1],
      });
      if (err) return;
      res.showField.forEach((item) => {
        item.isSelect = false;
      });
      res.hiddenField.forEach((item) => {
        item.isSelect = false;
      });
      this.paramDetailData = res;
    },
    // 自定义数据的回调
    initData(val) {
      this.getReport();
      this.getParamDetail();
    },
    // 切换助推累计tab
    orderpackageTypeClick(id) {
      if (this.tableActiveIndex === id) return;
      this.tableActiveIndex = id;
      // 重置某些查询数据
      this.sort_prop = "";
      this.sort_order = "";
      this.tableData.pageSize = 10;
      this.tableData.currentPage = 1;
      /**
       * 需要处理一下固定字段下面的数据，
       * 如果是助推累计数据不显示分日报表时间
       */
      /*       const excludeValue = [
        {
          label: "分日报表时间",
          prop: "date",
          fixed: false,
          ordernum: 0.9,
          width: 150,
          value: 1010,
        },
      ];
      if (id == 2) {
        this.fixedcolumn = excludeValue.concat(this.fixedcolumn);
      } else {
        // 需要把分日助推时间屏蔽掉
        this.fixedcolumn.splice(0, 1);
      }
      // 把分页改为1
      this.searchForm.currentPage = 1;
      // 切换table时也要把固定维度一起更改
      this.group = this[`group${id}`];
      // 处理自定义字段,重新切换到当前tab的所需字段
      this.paramDetailDataList = this[`paramDetailData${id}`];
      this.showchangeColumn();
      this.getOperateInvest(); */
      // 获取table表单数据
      this.getReport();
    },
    // 获取表格数据的接口函数
    async getReport() {
      this.tableData.loading = true;
      const { searchForm, group, tableOpt, sort } = this;
      const [err, res] = await this.$http.post("Operations_Overview/lists", {
        ...searchForm,
        ...tableOpt,
        ...sort,
        group: group.sort(function (a, b) {
          return a - b;
        }),
        timeStart: this.searchForm["time"][0],
        timeEnd: this.searchForm["time"][1],
        cate: 1,
      });
      if (err) {
        this.tableData = {
          list: [],
          total: 0,
          currentPage: 1,
          pageSize: 10,
          loading: false,
        };
        return;
      }
      this.tableData.loading = false;
      if (this.tableActiveIndex == 1) {
        this.column = JSON.parse(JSON.stringify(this.real_column));
      } else {
        this.column = JSON.parse(JSON.stringify(this.paper_column));
      }
      if (this.searchForm.timeType == "1") {
        this.timeTypeFlag = true;
      } else {
        this.timeTypeFlag = false;
      }
      const { list, currentPage, total, sumList, avgList } = res;
      const _list = await this.dealWithList(list); // 处理之后的数据
      const _sumList = await this.dealWithList([sumList]); // 处理之后的数据
      const _avgList = await this.dealWithList([avgList]); // 处理之后的数据
      _list.forEach(item => {
        if (item.date) {
          if (item.date.includes("~")) {
            let newTime = item.date.split(/\~/);
            newTime[0] = moment(newTime[0]).format('YYYY-MM-DD')
            newTime[1] = moment(newTime[1]).format('YYYY-MM-DD')
            console.log(newTime);
            item.date = newTime[0]+'~'+newTime[1]
          }else{

            item.date = moment(item.date).format('YYYY-MM-DD')
          }
        }
      })

      this.tableData.data = _list;
      this.tableData.currentPage = currentPage;
      this.tableData.total = total;
      this.sumList = _sumList[0];
      this.avgList = _avgList[0];
    },
    // 导出
    async leadOutClick(callBack) {
      this.tableData.loading = true;
      const { searchForm, group, tableOpt, sort } = this;
      const [err, res] = await this.$http.post("Operations_Overview/lists", {
        ...searchForm,
        ...sort,
        group: group.sort(function (a, b) {
          return a - b;
        }),
        timeStart: this.searchForm["time"][0],
        timeEnd: this.searchForm["time"][1],
        isDownload: 1,
      });
      if (err) return;
      let total_page =
        res.total_page || res.last_page || Math.ceil(res.total / 2000) || 0;
      let arr = [];
      if (res.data) {
        arr.push(...res.data);
      } else {
        arr.push(...res.list);
      }
      // 分页导出
      if (total_page > 0) {
        for (let index = 1; index < total_page; index++) {
          const [err, res] = await this.$http.post(
            "Operations_Overview/lists",
            {
              ...searchForm,
              ...tableOpt,
              ...sort,
              group: group.sort(function (a, b) {
                return a - b;
              }),
              timeStart: this.searchForm["time"][0],
              timeEnd: this.searchForm["time"][1],
              isDownload: 1,
              currentPage: index + 1,
            }
          );
          if (res.data) {
            arr.push(...res.data);
          } else {
            arr.push(...res.list);
          }
        }
      }
      arr.forEach((item) => {
        item.week = moment(item.date).format("dddd");
      });
      callBack.success(arr);
      this.tableData.loading = false;
    },
    // 处理list数据，新增需要为整数，roi需要为百分比
    dealWithList(list) {
      let _list = _.cloneDeep(list);
      return new Promise((resolve) => {
        let integerField = ["device_new"]; // 整数字段
        try {
          for (const i of _list) {
            for (const key in i) {
              // 处理成整数
              if (integerField.indexOf(key) > -1) {
                i[key] = parseInt(i[key]);
              }
              // 处理roi 为百分比 字段名称第一位是roi
              if (key.indexOf("roi") == 0) {
                i[key] = Number(i[key] * 100).toFixed(2) + "%";
              }
            }
          }
          resolve(_list);
        } catch (error) {
          resolve([]);
        }
      });
    },
    // 数据维度处理
    handleRemoveTag(removedTag) {
      if (this.group.length === 0) {
        // 如果只有一个选项被选中，不允许取消标签
        this.group.push(removedTag)
        this.$message.error('数据维度不可为空');
        return
      } else {
        // 允许取消标签
        const index = this.group.indexOf(removedTag);
        if (index > -1) {
          this.group.splice(index, 1);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.component_title2 {
  background: #fff;
  padding: 1px 0 10px 15px;
  font-weight: bold;
}

.component_title {
  background: #fff;
  padding: 20px 0 10px 15px;
  font-weight: bold;
}

.font14 {
  font-size: 14px;
}

.Tab_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;

  button {
    margin-right: 20px;
  }

  .left_box {
    line-height: 40px;
    // width: 1000px;
    display: flex;

    .btns {
      margin-left: 20px;
    }
  }
}

.my-select {
  height: 40px;
}

.check-all {
  padding: 0 20px;
  text-align: right;
}

.table-tabs {
  padding: 20px 0;
  text-align: center;
  background: #fff;

  .items {
    position: relative;
    margin: 0 15px;
    cursor: pointer;

    &:hover {
      color: #1890ff;
    }

    &:after {
      content: "";
      width: 2px;
      height: 20px;
      background: #ccc;
      position: absolute;
      right: -10%;
      top: 50%;
      transform: translateY(-50%);
    }

    &:nth-last-child(1)::after {
      width: 0;
    }
  }
}

.active {
  color: #1890ff;
}
</style>
